const EVENTS = [
  'beforeChange',
  'afterChange',
  'imageLoadComplete',
  'resize',
  'gettingData',
  'mouseUsed',
  'initialZoomIn',
  'initialZoomInEnd',
  'initialZoomOut',
  'initialZoomOutEnd',
  'parseVerticalMargin',
  'close',
  'unbindEvents',
  'destroy',
  'updateScrollOffset',
  'preventDragEvent',
  'shareLinkClick'
]

const ALBUM_TITLE_FOOTER_HEIGHT = 28
const FILENAME_FOOTER_HEIGHT = 48
const METADATA_FOOTER_PADDING = 12

export default class PswpEvents {
  metadataBottomGap (item) {
    let bottomGap = 0

    if (item && item.albumTitle) { bottomGap += ALBUM_TITLE_FOOTER_HEIGHT }
    if (item && item.filename) { bottomGap += FILENAME_FOOTER_HEIGHT }

    return bottomGap > 0 ? bottomGap + METADATA_FOOTER_PADDING : 0
  }

  constructor (store, props) {
    const pswp = store.currPswpGallery

    EVENTS.forEach((event) => {
      const callback = props[event]
      if (callback || event === 'destroy') {
        const self = this
        pswp.listen(event, function (...args) {
          if (callback) {
            args.unshift(this)
            callback(...args)
          }
          if (event === 'destroy') { self.handleClose(store, props) }
        })
      }
    })

    pswp.listen('gettingData', function(index, item) {
      if (item.w < 1 || item.h < 1) {
        var img = new Image();
        img.onload = function() {
          item.w = this.width
          item.h = this.height
          // reinit Items
          pswp.invalidateCurrItems()
          pswp.updateSize(true)
        }
        // download image
        img.src = item.src
      }
    })

    pswp.listen('parseVerticalMargin', (item) => {
      if (!item) { return }

      item.vGap = item.vGap || {}
      item.vGap.bottom = Math.max(item.vGap.bottom || 0, this.metadataBottomGap(item))
    })

    pswp.listen('afterChange', function () {
      const { uploadedAt, albumTitle, filename } = this.currItem
      document.querySelector('.pswp__uploaded-at').textContent = uploadedAt || ''
      document.querySelector('.pswp__album-title').textContent = albumTitle || ''
      document.querySelector('.pswp__filename').textContent = filename || ''
      store.pswpChanged()
    })
  }

  handleClose (store, { onClose }) {
    store.closePhotoswipe()
    if (onClose) { onClose() }
  }
}
